import { add, assertFiniteVec2, leftNormal, normalize, scale, subtract, } from "./vector.js";
export function buildArrowHead(tip, direction, parameters) {
    assertFiniteVec2(tip, "tip");
    assertFiniteVec2(direction, "direction");
    assertPositive("length", parameters.length);
    assertNonNegative("headHalfWidth", parameters.headHalfWidth);
    assertNonNegative("neckHalfWidth", parameters.neckHalfWidth);
    const unitDirection = normalize(direction);
    const normal = leftNormal(unitDirection);
    const neckCenter = subtract(tip, scale(unitDirection, parameters.length));
    const neckLeft = add(neckCenter, scale(normal, parameters.neckHalfWidth));
    const headLeft = add(neckCenter, scale(normal, parameters.headHalfWidth));
    const headRight = add(neckCenter, scale(normal, -parameters.headHalfWidth));
    const neckRight = add(neckCenter, scale(normal, -parameters.neckHalfWidth));
    const outline = [neckLeft, headLeft, { ...tip }, headRight, neckRight];
    return {
        neckCenter,
        neckLeft,
        headLeft,
        tip: { ...tip },
        headRight,
        neckRight,
        outline,
    };
}
function assertPositive(name, value) {
    if (!Number.isFinite(value) || value <= 0) {
        throw new RangeError(`${name} must be a positive finite number.`);
    }
}
function assertNonNegative(name, value) {
    if (!Number.isFinite(value) || value < 0) {
        throw new RangeError(`${name} must be a finite non-negative number.`);
    }
}
//# sourceMappingURL=arrow-components.js.map